/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

/** The base class for all HTTP error responses */
export class GoogleGenAiError extends Error {
  /** HTTP status code */
  public readonly statusCode: number | undefined;
  /** HTTP body */
  public readonly body: string;
  /** HTTP headers */
  public readonly headers: Headers | undefined;
  /** HTTP content type */
  public readonly contentType: string;
  /** Raw response */
  public readonly rawResponse: Response | undefined;

  constructor(
    message: string,
    httpMeta?: {
      response?: Response | undefined;
      request?: Request | undefined;
      body?: string | undefined;
    },
  ) {
    super(message);
    this.statusCode = httpMeta?.response?.status;
    this.body = httpMeta?.body ?? "";
    this.headers = httpMeta?.response?.headers;
    this.contentType = httpMeta?.response?.headers.get("content-type") || "";
    this.rawResponse = httpMeta?.response;

    this.name = "GoogleGenAiError";
  }
}
